module.exports = __webpack_public_path__ + "static/undp-logo-ccdcdec67abf739f91e97f043cb29597.png";